export class OtherSignUp {
  public currentJobTitle: string = '';
  public currentCompany: any = '';
  public passportCountries: string[] = [];
}
